// export const BASE_URL = "http://localhost:3002";
export const BASE_URL = "https://healthhive-server.onrender.com";

